import { useTranslation } from 'react-i18next';
import { Button } from '@scramble/ui';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { useWindowSize } from '@/hooks/useWindowSize';
import Star from './icon_star.svg';
import s from './index.module.scss';

const id = MODAL_IDS.verification_success_modal;
const LOCAL_STORAGE_KEY = 'verification_success_modal_show';

export const BonusVerificationSuccessModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

const Modal = () => {
  const { closeModal } = useModal();
  const { isMobile } = useWindowSize();
  const { t } = useTranslation('modal');

  const onClose = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, '1');
    closeModal(id);
  };

  const content = (
    <div className={s.modal}>
      <div className={s.header}>
        <div className={s.banner}>
          <div className={s.banner_inner}>
            {t('bonus_verification_success_modal.verification_bonus')}
            <img src={Star} alt="star" width={40} height={40} />
            <img src={Star} alt="star" width={40} height={40} />
            <img src={Star} alt="star" width={40} height={40} />
          </div>
        </div>
      </div>
      <div className={s.content}>
        <div className="f-headline-2xs f-500">
          {t('bonus_verification_success_modal.congratulations')}
        </div>
        <div className="f-body-sm">
          {t('bonus_verification_success_modal.successful_fulfillment')}
        </div>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="filled"
          label={t('bonus_verification_success_modal.got_it')}
          onClick={onClose}
        />
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalCenterLayout>
  );
};
